import { Mapper } from "../../../../base/utils/mapper";
import { TypeDocumentsModel } from "../../../../domain/models/consult/type-documents.model";
import { TypeDocumentsEntity } from "../entities/type-documents.entity";

export class TypeDocumentsImplementationRepositoryMapper extends Mapper<TypeDocumentsEntity, TypeDocumentsModel> {
    mapFrom(param: TypeDocumentsEntity): TypeDocumentsModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TypeDocumentsModel): TypeDocumentsEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}